import axios, { AxiosRequestConfig } from "axios";
import store from "../vuex/store";
import { OnlineNewsDTO } from "@/model/component.model";

export default class BannerService {
  getNews() {
    const config = {
      method: "GET",
      url: store.getters.BASE_API_URL + "/banner/online-news-list/online-user"
    } as AxiosRequestConfig;
    return axios
      .request(config)
      .then(res => {
        return res.data as OnlineNewsDTO[];
      })
      .catch(err => {
        console.error("Response failed with message: " + err.message);
        return Promise.reject(err);
      });
  }
}
